import { Injectable } from '@angular/core';
import { Facet, RoutingService } from '@spartacus/core';
import { FacetCollapseState, FacetList, FacetService, ProductFacetService } from '@spartacus/storefront';
import { BehaviorSubject, Observable, of, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class FacetKbService extends FacetService {
  currentParams: string;
  subscription = new Subscription();
  constructor(protected override productFacetService: ProductFacetService, private routingService: RoutingService) {
    super(productFacetService);
    this.subscription.add(this.routingService.getRouterState().subscribe((state) => {
      // console.log("state",state);
      if (state?.state?.params?.['query']) {
        this.currentParams = state.state.params['query'];

      }
      if (state?.state?.params?.['categoryCode']) {
        this.currentParams = state.state.params['categoryCode'];
      }

    }));
  }

  override facetList$: Observable<FacetList> = this.productFacetService.facetList$.pipe(
    tap((facetList) => {
      facetList.facets?.forEach((facet) => this.initialize(facet));
    })
  );
  override getState(facet: Facet): Observable<FacetCollapseState> {
    this.initialize(facet);
    return facet.name ? this.facetState.get(facet.name + this.currentParams) ?? of({}) : of({});
  }
  protected override initialize(facet: Facet): void {
    const topFacets = facet.topValueCount && facet.topValueCount > 0 ? facet.topValueCount : facet.values?.length || 0;

    if (facet.name && !this.hasState(facet)) {
      this.facetState.set(
        facet.name + this.currentParams,
        new BehaviorSubject({
          topVisible: topFacets,
          maxVisible: topFacets,
        } as FacetCollapseState)
      );
    }
  }

  protected override hasState(facet: Facet): boolean {
    if (facet.name) {
      return this.facetState.has(facet.name + this.currentParams);
    }
    return false;
  }
  protected override updateState(facet: Facet, property: FacetCollapseState): void {
    const state = { ...this.getStateSnapshot(facet), ...property };
    if (facet.name) {
      this.facetState.get(facet.name + this.currentParams)?.next(state);
    }
  }
  ngOnDestroy(): void {
    // Unsubscribe from the scroll event
    this.subscription.unsubscribe();
  }

}
